import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Page from "../../components/Page";

import TeammatesDetails from "../../components/InputFields/TeammatesDetails";
import AddedSkillers from "../../components/InputFields/AddedSkillers";
import AddedSkillersSidebar from "../../components/InputFields/AddedSkillersSiderbar";
import TeammateBox from "../../components/Boxs/TeammateBox";
import { url } from "../../url";
import TeammateFilters from "../../components/TeammateFilters/TeammateFilters";
import { teammatesAtom } from "./atoms/TeammateAtomGlobal";
import { userTeammatesAtom } from "./atoms/UserTeammatesAtomGlobal";
import Pagination from "@mui/material/Pagination";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgress from '@mui/material/CircularProgress';

import { useAtom } from "jotai";
import { Navigate } from "react-router-dom";
import styles from "./teammates.module.scss";

const Teammates = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [showSkillers, setShowSkillers] = useState(false);
  const [teammates, setTeammates] = useAtom<any[]>(teammatesAtom);
  const [userTeammates, setUserTeammates] = useAtom(userTeammatesAtom);
  const [userTeammateProfileId, setUserTeammateProfileId] = useState("");
  const [teammateAdded, setTeammateAdded] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [index, setIndex] = useState(2);
  const [error, setError] = useState(false);
  const [infoMsg, setInfoMsg] = useState("");

  // Centralna funkcja do wyświetlania JSON danych (z obsługą AI fallback)
  const displayJson = (jsonData: any) => {
    console.log("=== DISPLAY JSON FUNCTION CALLED (TEAMMATES) ===");
    console.log("Received JSON data:", jsonData);
    if (jsonData && jsonData.teammates) {
      setTeammates(jsonData.teammates);
      console.log("Teammates updated:", jsonData.teammates.length, "teammates");
      if (jsonData.teammates.length > 0 && jsonData.teammates[0].similarity !== undefined) {
        setInfoMsg("No exact matches found, showing closest teammates:");
      } else {
        setInfoMsg("");
      }
    } else if (Array.isArray(jsonData)) {
      setTeammates(jsonData);
      setInfoMsg("");
      console.log("Teammates array updated:", jsonData.length, "teammates");
    } else {
      console.warn("Invalid JSON data received:", jsonData);
      setInfoMsg("");
    }
    setLoading(false);
    console.log("=== DISPLAY JSON FUNCTION COMPLETED (TEAMMATES) ===");
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let teammates = null;
      try {
        teammates = await axios.get(url + `/teammate?page=1`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (err) {
        setError(true);
        setLoading(false);
        return;
      }
      const teammatesArr = teammates.data.teammates;
      displayJson(teammates.data);
      const morePages = teammates.data.teammatesPages == 1 ? false : true;
      if (!morePages) {
        setHasMore(false);
      }
      const token = localStorage.getItem("token");
      if (token) {
        const userTeammates = await axios.get(url + "/user/teammates/found", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const userTeammateArr = userTeammates.data.teammates;
        setUserTeammates(userTeammateArr);
        teammatesArr.forEach((teammate: any) => {
          if (userTeammateArr?.includes(teammate._id)) {
            setTeammateAdded((prevState: any) => ({
              ...prevState,
              [teammate._id]: true,
            }));
          } else {
            setTeammateAdded((prevState: any) => ({
              ...prevState,
              [teammate._id]: false,
            }));
          }
        });
        const TeammateProfile = await axios.get(url + "/user/myTeammate", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (TeammateProfile.data.userTeammateProfile?._id) {
          setUserTeammateProfileId(
            TeammateProfile.data.userTeammateProfile._id
          );
        }
      }
      setLoading(false);
    };
    fetchData();
  }, [setTeammates, setUserTeammates]);

  const fetchMoreTeammates = async () => {
    try {
      const res = await axios.get(url + `/teammates/?page=${index}`);
      const teammateArr = res.data.teammates;
      setTeammates((prevTeammates: any[]) => [...prevTeammates, ...teammateArr]);
      teammateArr.length > 0 ? setHasMore(true) : setHasMore(false);
      setIndex((prevIndex) => prevIndex + 1);
    } catch (err) {
      setHasMore(false);
    }
  };

  const handleShowFilters = () => {
    setShowFilters((prev) => !prev);
  };

  const tokenAvailable = () => {
    const token = localStorage.getItem("token");
    if (token) {
      return true;
    }
    return false;
  };

  const addTeammate = async (teammate: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.post(
          url + `/user/teammates/${teammate._id}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserTeammates([...userTeammates, teammate._id]);
      } catch (err) {
        console.log(err);
      }
    }
    setTeammateAdded((prevState: any) => ({
      ...prevState,
      [teammate._id]: true,
    }));
  };

  const deleteUserTeammates = async (teammate: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.delete(url + `/user/teammates/${teammate._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setUserTeammates(
          userTeammates.filter(function (t: any) {
            return t !== teammate._id;
          })
        );
      } catch (err) {
        console.log(err);
      }
    }
    setTeammateAdded((prevState: any) => ({
      ...prevState,
      [teammate._id]: false,
    }));
  };

  if (error) {
    return <Navigate to="/error" />;
  }
  return (
    <Page style={{ position: 'relative' }}>
      <section className="projects">
        <header className="container projects__header">
          <div className="projects__header__left"></div>
          <div className="projects__header__right">
            <div className="projects__header__right__skillerButton"></div>
          </div>
        </header>
        {/* Animowany przycisk X/Hamburger - zawsze w tej samej pozycji */}
        <div 
          onClick={handleShowFilters}
          style={{
            position: 'absolute',
            top: '120px', // Pozycja pod headerem
            left: '2rem',
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            background: '#327FFF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            zIndex: 1000,
            boxShadow: '0 2px 8px rgba(50, 127, 255, 0.3)',
            padding: '8px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3974d4';
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#327FFF';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {/* Animowany X/Hamburger */}
          <div style={{
            position: 'relative',
            width: '20px',
            height: '20px',
            transition: 'all 0.3s ease',
          }}>
            {/* Górna linia */}
            <div style={{
              position: 'absolute',
              top: showFilters ? '9px' : '0px',
              left: '0',
              width: '20px',
              height: '2px',
              background: 'white',
              borderRadius: '1px',
              transition: 'all 0.3s ease',
              transform: showFilters ? 'rotate(45deg)' : 'rotate(0deg)',
              transformOrigin: 'center',
            }} />
            {/* Środkowa linia */}
            <div style={{
              position: 'absolute',
              top: '9px',
              left: '0',
              width: '20px',
              height: '2px',
              background: 'white',
              borderRadius: '1px',
              transition: 'all 0.3s ease',
              opacity: showFilters ? '0' : '1',
            }} />
            {/* Dolna linia */}
            <div style={{
              position: 'absolute',
              top: showFilters ? '9px' : '18px',
              left: '0',
              width: '20px',
              height: '2px',
              background: 'white',
              borderRadius: '1px',
              transition: 'all 0.3s ease',
              transform: showFilters ? 'rotate(-45deg)' : 'rotate(0deg)',
              transformOrigin: 'center',
            }} />
          </div>
        </div>
        
        {/* Animowane filtry */}
        <div style={{
          opacity: showFilters ? 1 : 0,
          transform: showFilters ? 'translateY(0)' : 'translateY(-20px)',
          transition: 'all 0.3s ease',
          pointerEvents: showFilters ? 'auto' : 'none',
          visibility: showFilters ? 'visible' : 'hidden',
        }}>
          <TeammateFilters onDisplayJson={displayJson} onCloseFilters={handleShowFilters} />
        </div>
        {/* Komunikat o trybie i info */}
        {infoMsg && <div style={{textAlign:'center',color:'#FF5733',margin:'10px'}}>{infoMsg}</div>}
        <div className="projects__body" style={{
          transform: showFilters ? 'translateY(0)' : 'translateY(-400px)',
          transition: 'all 0.3s ease',
        }}>
          <div className="projects__body__container">
            <div className="projects__body__container__left">
              {loading && (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '20px' }}>
                  <CircularProgress style={{ color: '#3380FF' }} />
                </div>
              )}
              {!loading && teammates.length === 0 && (
                <div style={{textAlign:'center',color:'#FF5733',margin:'20px',fontSize:'1.2rem'}}>
                  Brak wyszukań
                </div>
              )}
              {teammates.length > 0 && (
                <InfiniteScroll
                  dataLength={teammates.length}
                  next={fetchMoreTeammates}
                  hasMore={hasMore}
                  loader={<div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '20px' }}><CircularProgress style={{ color: '#3380FF' }} /></div>}
                  className={styles.teammatesGrid}
                >
                  {teammates.map((teammate: any) => {
                    const isMyTeammate = userTeammateProfileId?.includes(teammate._id);
                    const props = {
                      teammate: teammate,
                      loading: loading,
                      tokenAvailable: !isMyTeammate && tokenAvailable(),
                      addTeammate: !isMyTeammate ? () => addTeammate(teammate) : undefined,
                      deleteTeammate: !isMyTeammate ? () => deleteUserTeammates(teammate) : undefined,
                      teammateAdded: !isMyTeammate && teammateAdded[teammate._id],
                    }
                    return (
                      <div className={styles.teammateCard} key={teammate._id}>
                        <TeammateBox {...props} />
                      </div>
                    );
                  })}
                </InfiniteScroll>
              )}
            </div>
            {/* <div className="projects__body__container__right">
                <AddedSkillers />
              </div> */}
          </div>
        </div>
        <div></div>
      </section>
    </Page>
  );
};

export default Teammates;
